import { Component, OnInit, Inject, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { ErrorcontrolService } from 'basecomponents';
import { MessageError } from 'base-models';



@Component({
  selector: 'app-file-chooser',
  templateUrl: './file-chooser.component.html',
  styleUrls: []
})
export class FileChooserComponent implements OnInit {
  /**
   * name to identify the class
   */
  TAG: string = "FileChooserComponent";

  private _fileMessagePlaceholder: string = "Choose file";
  private _fileMessagePlaceholder_backup: string = "Choose file with GeoData";
  @Input() acceptFilter:string="";
  @Input() public get fileMessagePlaceholder(): string {
    return this._fileMessagePlaceholder;
  }
  public set fileMessagePlaceholder(value: string) {
    this._fileMessagePlaceholder = value;
    this._fileMessagePlaceholder_backup = value;
  }
  @Output() fileSelectedEvent:EventEmitter<File>=new EventEmitter<File>();
  /**
   * File selected by user
   */
  fileSelected:any;  

  hasBaseDropZoneOver: boolean = false;
  myform: FormGroup;
  alertmessage: MessageError | string;

  constructor(
    private fb: FormBuilder,

  ) {
    
    this.createForm();
  }

  ngOnInit() {
  }

  createForm() {
    this.myform = this.fb.group({
      filename: ['', [Validators.required]],
    });
  }  

  showerror(message: string, err?: any) {
    this.alertmessage = ErrorcontrolService.basichandleError(message, err, null, this.TAG);
  }

  isvalid() {
    if (this.fileSelected == null || this.fileSelected.length == 0) {
      return false;
    }
    return true;
  }
 
  fileChangeEvent($event) {
    try {
      //console.log("fileChangeEvent", event);
      let files = $event.target.files;

      this.fileSelected=files;
      this.fileSelectedEvent.emit(files);
      if (files.length==0){
        this._fileMessagePlaceholder ="No file selected";
      }else if(files.length==1){
        let fileName=files[0].name;
        this._fileMessagePlaceholder = fileName;
      }
      else if (files.length>1){
        //no existe este caso pero lo medio dejamos
        //this._fileMessagePlaceholder = msg;
      }
      

    }
    catch (err) {
      this.showerror("Error ocurred with file selected. ", err);
    }

  }
}
